import { useContext } from 'react'

import { FrontChatContext } from '@/contexts/front-chat-context'

function useFrontChat() {
  return useContext(FrontChatContext)
}

export { useFrontChat }
